export default {"src":"/_next/static/media/multimedia-icon.4cbb0747.svg","height":500,"width":500};